import { useSelector } from "react-redux";
import { AnyAction, ThunkAction } from "@reduxjs/toolkit";
//
import { RootState } from "store/store";
import { useAppDispatch } from "./useAppDispatch";

interface SliceHookOptions<State, Params, Payload> {
  sliceName: keyof RootState;
  thunk: (params: Params) => ThunkAction<Promise<Payload>, RootState, unknown, AnyAction>;
}

export const useSlice = <State, Params, Payload>({
  sliceName,
  thunk,
}: SliceHookOptions<State, Params, Payload>) => {
  const dispatch = useAppDispatch();
  const sliceState = useSelector((state: RootState) => state[sliceName] as State);

  const fetch = (params: Params) => dispatch(thunk(params));

  return { ...sliceState, fetch };
};
